import { render } from "./confirm-email.vue?vue&type=template&id=7d2b2d6a"
import script from "./confirm-email.vue?vue&type=script&lang=ts"
export * from "./confirm-email.vue?vue&type=script&lang=ts"
script.render = render

export default script